# Where a signed-in account lands, decided from the account as the server
# holds it (card 6a9cc47fdbd420ed5794d248).
#
# app-route.coffee sent EVERY zero-student account to #/application, the
# enrollment checkout, before it asked whether the account was already paying.
# A parent whose subscription is live (status Subscribed, subscription_end in
# the future — the same test Login.role uses server-side to mint the
# Login.subscribed role) and who has removed every student was walked through
# the whole form, minted a SetupIntent, entered a card, and had the final
# Account.subscribe refused with a raw 401: that role holds no subscribe grant,
# so the friendly "you already have a subscription" 409 behind it can never
# reach the one person it was worded for.
#
# OWNER DECISION 2026-09-06: a routing fix, NOT an ACL grant. A zero-student
# account that is currently Subscribed goes to the Students screen — the
# Students tab of #/account, where a student is added and saved — and never
# into the checkout. Account.subscribe stays closed to Login.subscribed.
#
# CommonJS on purpose, like StudentApplication/enrollRedirect.coffee: webpack
# imports it either way, and the suite requires it and drives it directly.
moment = require 'moment'

# The one definition of "currently subscribed" the client routes on. The
# server's is Login.role (common/models/Login.coffee); keep them the same test
# or the client will route a parent into a form the ACL then refuses.
isActiveSubscription = (account, now = moment()) ->
  return false unless account?.status == 'Subscribed' and account.subscription_end?
  # subscription_end is required explicitly: moment(undefined) is "now", which
  # would read a Subscribed row with no end date as active until the clock
  # ticked. The server's role reads the same row as unsubscribed.
  moment(account.subscription_end).isAfter(now)

# A paying account with nobody to teach: nothing to buy, someone to add.
subscribedWithoutStudents = (account, students, sharedStudents, now = moment()) ->
  return false unless isActiveSubscription account, now
  (students?.length ? 0) == 0 and (sharedStudents?.length ? 0) == 0

# The enrollment form's Step 2 -> Step 3 gate. The decision must be made on
# the account as the SERVER holds it now: app.account is the tree from the
# last refresh, which can predate a subscription made since (another tab, the
# app store, an agent). So re-read, then decide — and if the re-read fails,
# decide on the last known state rather than strand the parent on a spinner;
# the server's ACL is the backstop either way.
activeSubscriptionAfterRefresh = (app, now = moment()) ->
  try
    await app.refresh()
  catch err
    console.error "Could not re-read the account before Step 3; deciding on the last known state"
    console.dir err
  isActiveSubscription app.account, now

# The Students tab of the account screen. ManageAccount/account.coffee builds
# its tabs in order — Account Information, then Students (or Manage Classroom
# for a teacher) — for every account class that reaches this router, so the
# tab index is 1. Organization/app-route.coffee sends its own zero-student
# case to the same place.
STUDENTS_SCREEN_HASH = '#/account?tab=1'

module.exports = {
  isActiveSubscription
  subscribedWithoutStudents
  activeSubscriptionAfterRefresh
  STUDENTS_SCREEN_HASH
}
